import React from 'react'
import Modal from 'scripts/lib/Modal'
import Login from 'scripts/lib/firebase/login'
import locale from 'shared/i18n/react'
import Constants from 'scripts/base/Constants'

export default class UserCta extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      alert: {title: '', message: ''}
    }
    this.lang = locale.getLanguage() || Constants.DefaultLang
  }

  loginOnClick = () => {
    this.setState({
      open: true,
      alert: {
        title: locale.comment.dialogTitle,
        message: this.setMessage()
      }
    })
  }

  setMessage = () => {
    return (
      <React.Fragment>
        <Login toggleWithId={() => this.setState({open: false})} />
      </React.Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
        <div className="comment-cta center-align">
          {locale.formatString(locale.comment.loginCta, <a href="javascript:;" onClick={() => this.loginOnClick()}>{locale.comment.loginCtaButton}</a>)}
        </div>
        <Modal open={this.state.open} alert={this.state.alert} classNames={{overlay: 'modal-alert-overlay'}} closeBtn={` `} />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/disqus/UserCta.jsx